module.exports = __webpack_public_path__ + "ty2-b571e1d6.png";